import { type Metric } from '../vessel_data'

export enum StabilizerMetric {
  stabilizerForwardPort = 'stabilizerForwardPort',
  stabilizerForwardStbd = 'stabilizerForwardStbd',
  stabilizerAftPort = 'stabilizerAftPort',
  stabilizerAftStbd = 'stabilizerAftStbd',
}

export type StabilizerMetricName = keyof typeof StabilizerMetric

export type StabilizerMetrics = Record<StabilizerMetricName, Metric>

export const allStabilizerMetricNames: StabilizerMetricName[] = Object.values(StabilizerMetric)
